import { combineReducers } from 'redux';

import { columnsReducer } from './columns/columns.reducer';
import type { DailyBlotterState } from './dailyBlotter.model';
import { infosReducer } from './infos/infos.reducer';
import { quotesReducer } from './quotes/quotes.reducer';

export const dailyBlotterReducer = combineReducers<DailyBlotterState>({
  columnDefinitions: columnsReducer,
  infos: infosReducer,
  quotes: quotesReducer,
});
